import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { AttachMoney, LocalHospital,DirectionsBus } from '@material-ui/icons';
import MenuItem from '@material-ui/core/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, } from 'reactstrap';
import { useHistory } from "react-router-dom";
import AlertModal from '../../../../shared/components/Modal';
import { Budget } from './Budget';

const UpdateActivity = ({ updateActivitiesModal, closeActivitiesModal, opened, actividad, actividades }) => {
    const history = useHistory();

    const [openModal, setOpenModal] = React.useState(opened);

    const [defaultValueNombre, setDefaultValueNombre] = React.useState({ activity: actividad.nombre });

    //Atributos
    const [nombre, setNombre] = React.useState(actividad.nombre);
    const [costo, setCosto] = React.useState(actividad.costo);
    const [costo_patrocinador, setCostoPatrocinador] = React.useState(actividad.costo_patrocinador);
    const [precio, setPrecio] = React.useState(actividad.precio);

    const [overhead_check, setOverheadCheck] = React.useState(actividad.overhead_check);
    const [autoCompleteUsed, setAutocompleteUsed] = React.useState(false);
    const [check_transporte, setCheckTransporte] = React.useState(false);

    //Alerta
    const [showAlertModal, setAlerShowModal] = React.useState(false);
    const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
    const [colorAlertModal, setAlertColorModal] = React.useState("success");

    const alertModal = (success, message) => {
        if (success == true) {
            setAlertColorModal("success");
        }
        else {
            setAlertColorModal("danger");
        }
        setAlerShowModal(true);
        setAlertMessageModal(message);
    }

    const updateActivityBudget = async () => {

        //Validaciones
        if (nombre == null) {
            alertModal(false, "El nombre es Requerido");
            return;
        }
        if (costo == null || costo <= 0) {
            alertModal(false, "El Costo debe ser mayor a 0");
            return;
        }
        if (costo_patrocinador == null || costo_patrocinador <= 0) {
            alertModal(false, "El Presupuesto del Patrocinador debe ser mayor a 0");
            return;
        }
        if (precio == null || precio <= 0) {
            alertModal(false, "El Precio de Venta debe ser mayor a 0");
            return;
        }
        else {
            if (parseFloat(costo) > parseFloat(precio)) {
                alertModal(false, "El Precio de Venta debe ser mayor al Costo");
                return;
            }
        }

        if (overhead_check == null) {
            alertModal(false, "Debe elegir si manejara o no Overhead");//
            return;
        }

        let actividadJSON =
        {
            nombre: nombre,
            costo: costo,
            costo_patrocinador: costo_patrocinador,
            precio: precio,
            overhead_check: overhead_check,
            maneja_overhead: overhead_check == true ? "SI" : "NO",
            ok_presupuesto: parseFloat(precio) > parseFloat(costo_patrocinador) ? "SI" : "NO",
            check_transporte:check_transporte
        }


        let submitJSON = {
            actividad: actividadJSON,
            position: actividad.position,
            id_visita: actividad.id_visita
        }

        console.log(submitJSON);

        fetch(`${process.env.REACT_APP_PUBLIC_URL}visitas/actualizar-actividad`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(submitJSON)
        }).then(response => response.json()).then(data => {
            closeActivitiesModal(true);
            alertModal(true, "Actividad Actualizada correctamente");
        }).catch(err => {
            console.log(err);
            alertModal(false, "Ha ocurrido un error actualizando la actividad");
        });
    }

    React.useEffect(() => {
        if(actividad.check_transporte !== undefined && actividad.check_transporte !== null) 
        {
            setCheckTransporte(actividad.check_transporte);
        }
        setOpenModal(opened);
    }, []);

    const handleAutocompleteName = (event, values) => {
        console.log("Usando Autocomplete");
        if (values != null) {
            setNombre(values.activity);
            setAutocompleteUsed(true);
        }
        else {
            setNombre(null);
            setAutocompleteUsed(false);
        }

    }

    const handleChangeName = (value) => {
        setAutocompleteUsed(false);
        if (autoCompleteUsed == false && value != null) {
            setNombre(value);
        }
        else {
            setAutocompleteUsed(false);
            setNombre(null);
        }
    }

    const verifyCloseModal = () => {
        setAlerShowModal(false);

        if (colorAlertModal == "success") {
            let _url = "/clinical-studio/budget";

            if (colorAlertModal == "success") {
                if (window.location.pathname === process.env.PUBLIC_URL + '/clinical-studio/budget') {
                    history.replace(process.env.PUBLIC_URL+"/");
                    setTimeout(() => {
                        history.replace({
                            pathname: process.env.PUBLIC_URL +_url,
                            state: actividad.feasibility
                        });
                    }, 0);
                } else {
                    history.push({
                        pathname: process.env.PUBLIC_URL +_url,
                        state: actividad.feasibility
                    });
                }
            }
        }
    }

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    setOpenModal(false);
                    closeActivitiesModal(false);
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>

                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Actualizar Actividad</h5>
                        </div>

                        <Row>
                            <Col md={6}>
                                <Grid container spacing={1} alignItems="flex-end">
                                    <Grid item>
                                        <LocalHospital />
                                    </Grid>
                                    <Grid item>
                                        <Autocomplete
                                            id="input-with-icon-grid"
                                            options={actividades}
                                            getOptionLabel={(option) => option.activity ? option.activity : ""}
                                            debug
                                            noOptionsText="No hay opciones de Actividades"
                                            value={defaultValueNombre}
                                            //defaultValue={defaultValueNombre}
                                            onChange={handleAutocompleteName}
                                            freeSolo={true}
                                            renderInput={(params) => (

                                                <TextField
                                                    onChange={(event) => handleChangeName(event.target.value)}
                                                    style={{ minWidth: '300px', maxWidth: '100%' }}

                                                    {...params} label="Actividad"
                                                    className="medical-material-form__field"
                                                    InputLabelProps={{
                                                        style: { color: '#646777' }
                                                    }}
                                                />
                                            )}
                                        />

                                    </Grid>
                                </Grid>
                            </Col>
                            <Col md={6}>
                                <Grid container spacing={1} alignItems="flex-end">
                                    <Grid item>
                                        <AttachMoney />
                                    </Grid>
                                    <Grid item>
                                        <TextField
                                            onChange={(e) => {
                                                setCosto(e.target.value);
                                                //console.log(costo);
                                            }}
                                            style={{ minWidth: '300px', maxWidth: '100%' }}
                                            id="input-with-icon-grid"
                                            type="number"
                                            label="Costo"
                                            value={costo}
                                            className="medical-material-form__field"
                                                    InputLabelProps={{
                                                        style: { color: '#646777' }
                                                    }}

                                        />
                                    </Grid>
                                </Grid>
                            </Col>
                            <Col md={6}>
                                <Grid container spacing={1} alignItems="flex-end">
                                    <Grid item>
                                        <AttachMoney />
                                    </Grid>
                                    <Grid item>
                                        <TextField
                                            onChange={(e) => {
                                                setCostoPatrocinador(e.target.value);
                                            }}
                                            type="number"
                                            style={{ minWidth: '300px', maxWidth: '100%' }}
                                            id="input-with-icon-grid"
                                            label="Propuesta del Patrocinador"
                                            value={costo_patrocinador}
                                            className="medical-material-form__field"
                                                    InputLabelProps={{
                                                        style: { color: '#646777' }
                                                    }}
                                        />
                                    </Grid>
                                </Grid>
                            </Col>
                            <Col md={6}>
                                <Grid container spacing={1} alignItems="flex-end">
                                    <Grid item>
                                        <AttachMoney />
                                    </Grid>
                                    <Grid item>
                                        <TextField
                                            onChange={(e) => {
                                                setPrecio(e.target.value);
                                            }}
                                            type="number"
                                            style={{ minWidth: '300px', maxWidth: '100%' }}
                                            id="input-with-icon-grid"
                                            label="Precio"
                                            value={precio}
                                            className="medical-material-form__field"
                                                    InputLabelProps={{
                                                        style: { color: '#646777' }
                                                    }}
                                        />
                                    </Grid>
                                </Grid>
                            </Col>
                            
                            <Col md={6}>
                                <Grid container spacing={1} alignItems="flex-end">
                                    <Grid item>
                                        <AttachMoney />
                                    </Grid>
                                    <Grid item>
                                        <TextField
                                            id="standard-select-currency"
                                            select
                                            label=" "
                                            helperText="Seleccione si la maneja Overhead"
                                            value={overhead_check}

                                            onChange={(event) => {
                                                setOverheadCheck(event.target.value);
                                            }}

                                            style={{ minWidth: '300px', maxWidth: '100%' }}
                                            className="medical-material-form__field"
                                                    InputLabelProps={{
                                                        style: { color: '#646777' }
                                                    }}
                                        >
                                            <MenuItem key={0} value={true}>
                                                SI
                                            </MenuItem>
                                            <MenuItem key={1} value={false}>
                                                NO
                                            </MenuItem>
                                        </TextField>
                                    </Grid>
                                </Grid>
                            </Col>
                            <Col md={6}>
                                <Grid container spacing={1} alignItems="flex-end">
                                    <Grid item>
                                        <DirectionsBus />
                                    </Grid>
                                    <Grid item>
                                        <TextField
                                            id="standard-select-maneja_todos"
                                            select
                                            label=" "
                                            helperText="Es transporte o refrigerio"
                                            value={check_transporte}

                                            onChange={(event) => {
                                                setCheckTransporte(event.target.value);
                                            }}

                                            style={{ minWidth: '300px', maxWidth: '100%' }}
                                            className="medical-material-form__field"
                                            InputLabelProps={{
                                                style: { color: '#646777' }
                                            }}
                                        >
                                            <MenuItem key={0} value={true}>
                                                SI
                                            </MenuItem>
                                            <MenuItem key={1} value={false}>
                                                NO
                                            </MenuItem>
                                        </TextField>
                                    </Grid>
                                </Grid>
                            </Col>
                        </Row>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                updateActivityBudget();
                            }}
                        >
                            Actualizar
                        </Button>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                setOpenModal(false);
                                closeActivitiesModal(false);
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => verifyCloseModal()}
                toggle={() => verifyCloseModal()}
            />
        </div>
    );
};
export default UpdateActivity;
